var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOccasionPartyLow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1024,
    height: 1024,
    fill: "#675043"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(4.000000) translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffecbd",
    fillOpacity: 0.501961,
    points: "271,106 0,45 253,-16"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillOpacity: 0.501961,
    points: "-16,58 0,238 244,215"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "271,215 233,271 243,85"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#180000",
    fillOpacity: 0.501961,
    points: "132,271 247,182 196,20"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#dec9b3",
    fillOpacity: 0.501961,
    points: "176,167 123,5 114,194"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillOpacity: 0.501961,
    points: "132,117 99,35 10,271"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fffff7",
    fillOpacity: 0.501961,
    points: "263,-16 134,-6 260,61"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#6b2b0f",
    fillOpacity: 0.501961,
    points: "-16,53 39,190 115,42"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#120000",
    fillOpacity: 0.501961,
    points: "-16,1 126,25 -11,39"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "236,136 271,76 254,246"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillOpacity: 0.501961,
    points: "165,47 201,31 213,61"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#1d0000",
    fillOpacity: 0.501961,
    points: "222,87 241,209 146,116"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffe5ac",
    fillOpacity: 0.501961,
    points: "204,183 152,157 210,168"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffde",
    fillOpacity: 0.501961,
    points: "131,53 182,25 69,34"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a1998a",
    fillOpacity: 0.501961,
    points: "131,-16 -7,1 219,39"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillOpacity: 0.501961,
    points: "156,150 120,229 169,271"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e7fcef",
    fillOpacity: 0.501961,
    points: "145,110 136,175 111,141"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#c99467",
    fillOpacity: 0.501961,
    points: "125,261 112,197 76,221"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillOpacity: 0.501961,
    points: "117,191 -8,260 111,61"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f2ab82",
    fillOpacity: 0.501961,
    points: "94,60 47,124 64,69"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#00012d",
    fillOpacity: 0.501961,
    points: "171,173 243,194 214,271"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffecda",
    fillOpacity: 0.501961,
    points: "129,96 204,65 114,74"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f3a17c",
    fillOpacity: 0.501961,
    points: "145,38 191,102 204,73"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffcda9",
    fillOpacity: 0.501961,
    points: "42,271 54,236 33,226"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffee62",
    fillOpacity: 0.501961,
    points: "-16,37 85,34 22,54"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#070200",
    fillOpacity: 0.501961,
    points: "153,75 138,68 150,37"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f7ffff",
    fillOpacity: 0.501961,
    points: "162,83 152,27 172,25"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f0e9c4",
    fillOpacity: 0.501961,
    points: "264,271 227,237 247,203"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2b0000",
    fillOpacity: 0.501961,
    points: "191,118 181,86 133,150"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillOpacity: 0.501961,
    points: "150,114 136,111 156,87"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffc296",
    fillOpacity: 0.501961,
    points: "72,121 82,109 65,72"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cace9c",
    fillOpacity: 0.501961,
    points: "209,78 216,1 271,147"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ecffdd",
    fillOpacity: 0.501961,
    points: "155,97 153,121 175,86"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#3a1303",
    fillOpacity: 0.501961,
    points: "44,102 -7,53 82,50"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#830400",
    fillOpacity: 0.501961,
    points: "154,186 138,139 173,176"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillOpacity: 0.501961,
    points: "207,39 209,73 173,36"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillOpacity: 0.501961,
    points: "57,239 52,166 -16,198"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2b2932",
    fillOpacity: 0.501961,
    points: "253,134 251,92 244,117"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2a0000",
    fillOpacity: 0.501961,
    points: "81,40 117,100 104,45"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#370000",
    fillOpacity: 0.501961,
    points: "202,69 219,183 242,121"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#6a7375",
    fillOpacity: 0.501961,
    points: "160,187 117,199 114,148"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "252,118 271,110 253,42"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ed9563",
    fillOpacity: 0.501961,
    points: "86,30 91,101 74,62"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#180000",
    fillOpacity: 0.501961,
    points: "53,271 86,244 51,231"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillOpacity: 0.501961,
    points: "53,137 65,93 75,137"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d68e6a",
    fillOpacity: 0.501961,
    points: "172,173 148,146 175,127"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "269,128 250,203 238,139"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#240000",
    fillOpacity: 0.501961,
    points: "-16,2 87,18 -11,41"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillOpacity: 0.501961,
    points: "-10,265 32,235 43,271"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000009",
    fillOpacity: 0.501961,
    points: "160,271 182,176 107,212"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#9a5a26",
    fillOpacity: 0.501961,
    points: "188,214 191,271 153,226"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#8e422b",
    fillOpacity: 0.501961,
    points: "165,84 176,21 184,92"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#9a715d",
    fillOpacity: 0.501961,
    points: "7,229 19,209 16,268"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#765c4d",
    fillOpacity: 0.501961,
    points: "190,24 103,28 158,6"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#100000",
    fillOpacity: 0.501961,
    points: "68,58 83,113 83,77"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#dcc998",
    fillOpacity: 0.501961,
    points: "129,117 115,127 131,90"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a76c3d",
    fillOpacity: 0.501961,
    points: "77,211 80,271 152,259"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#3d120e",
    fillOpacity: 0.501961,
    points: "145,119 165,151 197,110"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffd9b6",
    fillOpacity: 0.501961,
    points: "46,116 52,124 63,92"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0c0000",
    fillOpacity: 0.501961,
    points: "221,162 204,81 175,163"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#010000",
    fillOpacity: 0.501961,
    points: "-16,220 99,204 120,109"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#845039",
    fillOpacity: 0.501961,
    points: "43,169 65,130 65,161"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f09e78",
    fillOpacity: 0.501961,
    points: "157,164 208,165 211,183"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e6ece0",
    fillOpacity: 0.501961,
    points: "146,144 122,129 146,107"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#b5a396",
    fillOpacity: 0.501961,
    points: "74,231 72,215 57,230"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillOpacity: 0.501961,
    points: "179,36 163,52 199,42"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffe16d",
    fillOpacity: 0.501961,
    points: "74,47 112,28 25,40"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7a2900",
    fillOpacity: 0.501961,
    points: "17,37 45,18 107,29"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff4be",
    fillOpacity: 0.501961,
    points: "159,25 86,33 132,62"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#eea376",
    fillOpacity: 0.501961,
    points: "204,81 198,57 186,109"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7a4728",
    fillOpacity: 0.501961,
    points: "4,139 0,51 35,114"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d0c7ad",
    fillOpacity: 0.501961,
    points: "182,26 177,-16 233,58"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#3d597d",
    fillOpacity: 0.501961,
    points: "193,212 187,271 214,222"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f2fffb",
    fillOpacity: 0.501961,
    points: "164,36 169,75 148,88"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#353536",
    fillOpacity: 0.501961,
    points: "128,114 151,114 151,79"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "255,88 247,-16 271,37"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000004",
    fillOpacity: 0.501961,
    points: "192,218 192,235 174,237"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000012",
    fillOpacity: 0.501961,
    points: "231,245 191,261 224,218"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#836036",
    fillOpacity: 0.501961,
    points: "145,57 142,68 111,65"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#170d08",
    fillOpacity: 0.501961,
    points: "24,134 57,65 60,93"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fdb988",
    fillOpacity: 0.501961,
    points: "66,71 56,74 70,98"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#b5ab92",
    fillOpacity: 0.501961,
    points: "201,-16 167,21 94,13"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#8a1537",
    fillOpacity: 0.501961,
    points: "244,185 226,150 238,134"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillOpacity: 0.501961,
    points: "52,143 70,117 38,128"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#841c00",
    fillOpacity: 0.501961,
    points: "101,242 115,260 102,210"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#9c9483",
    fillOpacity: 0.501961,
    points: "151,264 118,269 104,211"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a24700",
    fillOpacity: 0.501961,
    points: "128,103 119,120 111,63"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#bfd0af",
    fillOpacity: 0.501961,
    points: "248,138 232,95 245,59"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#390000",
    fillOpacity: 0.501961,
    points: "112,58 88,43 98,113"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffdd80",
    fillOpacity: 0.501961,
    points: "53,37 9,52 -10,40"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillOpacity: 0.501961,
    points: "100,219 118,95 78,99"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#904422",
    fillOpacity: 0.501961,
    points: "145,159 153,125 135,145"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a0a795",
    fillOpacity: 0.501961,
    points: "112,145 140,192 148,161"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillOpacity: 0.501961,
    points: "192,271 132,208 131,241"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f9e6dc",
    fillOpacity: 0.501961,
    points: "167,78 116,70 136,94"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#651200",
    fillOpacity: 0.501961,
    points: "72,231 84,206 84,257"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d5cbb0",
    fillOpacity: 0.501961,
    points: "229,271 244,181 271,254"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#eb8456",
    fillOpacity: 0.501961,
    points: "89,81 96,91 82,102"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a1aca6",
    fillOpacity: 0.501961,
    points: "83,210 101,223 91,234"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "264,48 268,27 224,49"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOccasionPartyLow);
export default __webpack_public_path__ + "static/media/occasion_party_low.b689e7dac017bf83073453f1eca116b4.svg";
export { ForwardRef as ReactComponent };